import api from '@utils/api';
import config from '@/config';

const visitTypeCategoryService = {
  getVisitTypeCategories: async (params = {}) => {
    return api.get(config.endpoints.visitTypeCategories.list, params);
  },

  getVisitTypeCategoryById: async (id) => {
    return api.get(`${config.endpoints.visitTypeCategories.getById}/${id}`);
  },

  createVisitTypeCategory: async (visitTypeCategoryData) => {
    return api.post(config.endpoints.visitTypeCategories.create, visitTypeCategoryData);
  },

  updateVisitTypeCategory: async (visitTypeCategoryData) => {
    return api.put(`${config.endpoints.visitTypeCategories.update}/${visitTypeCategoryData.id}`, visitTypeCategoryData);
  },

  deleteVisitTypeCategory: async (id) => {
    return api.delete(`${config.endpoints.visitTypeCategories.delete}/${id}`);
  },

  bulkDeleteVisitTypeCategories: async (ids) => {
    return api.delete(config.endpoints.visitTypeCategories.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null,
      },
    });
  },
};

export default visitTypeCategoryService;

